import { Component, OnInit, Input, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../../shared/material/material.module';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { AccessPlan } from '../../../../core/generated';
import { ExternalPayerService } from '../services/external-payer.service';
import { ConfirmPaymentModalComponent } from '../confirm-payment-modal/confirm-payment-modal.component';
import { fadeIn, listStagger } from '../../shared/animations';

@Component({
  selector: 'app-payer-plans',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './payer-plans.component.html',
  styleUrl: './payer-plans.component.scss',
  animations: [fadeIn, listStagger]
})
export class PayerPlansComponent implements OnInit {
  @Input() userCpf!: string;

  private externalPayerService = inject(ExternalPayerService);
  private snackBar = inject(MatSnackBar);
  private dialog = inject(MatDialog);

  plans = signal<AccessPlan[]>([]);
  isLoading = signal(false);

  ngOnInit(): void {
    this.loadPlans();
  }

  loadPlans(): void {
    if (!this.userCpf) return;
    this.isLoading.set(true);
    this.externalPayerService.getAcceptedPlansByUserCpf(this.userCpf).subscribe({
      next: (data) => { this.plans.set(data); this.isLoading.set(false); },
      error: () => { this.snackBar.open('Erro ao carregar planos.', 'Fechar', { duration: 4000 }); this.isLoading.set(false); }
    });
  }

  openConfirmModal(plan: AccessPlan): void {
    const ref = this.dialog.open(ConfirmPaymentModalComponent, {
      data: { plan },
      width: '560px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      panelClass: 'confirm-payment-dialog'
    });
    ref.afterClosed().subscribe(payment => {
      if (payment) this.loadPlans();
    });
  }

  /** Retorna o status visual do plano com pagador externo */
  getPayerStatus(plan: AccessPlan): 'awaiting-acceptance' | 'accepted' | 'awaiting-confirmation' | 'payment-active' | 'none' {
    if (!plan.payerCnpj) return 'none';
    if (plan.payerAccepted == null) return 'awaiting-acceptance';
    if (plan.payerAccepted && !plan.paymentRequestedAt) return 'accepted';
    if (plan.payerAccepted && plan.paymentRequestedAt) return 'awaiting-confirmation';
    return 'payment-active';
  }

  canConfirmPayment(plan: AccessPlan): boolean {
    return !!plan.paymentRequestedAt && plan.payerAccepted === true;
  }

  formatCurrency(value?: number): string {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value ?? 0);
  }

  formatCnpj(cnpj?: string): string {
    if (!cnpj) return 'N/A';
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }
}
